<template>
  <a-modal
    class="upload-modal"
    :title="title"
    :visible="visible"
    @ok="handleUpload"
    @cancel="handleCancel"
  >
    <div class="content">
      <div class="upload-file">
        <a-button class="file-button" v-if="!file">
          <img src="@/assets/icons/icon_upload.png" alt="" srcset="" />
          <div class="text">{{ $t('components.uploadModal.selectFile') }}</div>
        </a-button>
        <input ref="fileInput" class="file" type="file" :accept="accept" @change="handleFileChange" />
      </div>
      <div v-if="file" class="success">{{ $t('components.uploadModal.fileUploaded') }}</div>
      <div v-else class="fileTemplate" @click="handleTemplateDownload">
        <span>{{ $t('components.uploadModal.downloadTemplate') }}</span><span>{{ $t('components.uploadModal.importTemplate') }}</span>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'UploadModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: function() {
        return this.$t('components.uploadModal.title')
      }
    },
    accept: {
      type: String,
      default: '.xlsx, .xls'
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.file = null
        this.$nextTick(() => {
          this.$refs.fileInput.value = ''
        })
      }
    }
  },
  data() {
    return {
      file: null
    }
  },
  methods: {
    handleFileChange(e) {
      this.file = e.target.files[0]
      this.$emit('fileChange', this.file)
    },
    handleUpload() {
      this.$emit('upload', this.file)
      this.$refs.fileInput.value = ''
    },
    handleCancel() {
      this.file = null
      this.$emit('cancel')
    },
    handleTemplateDownload() {
      this.$emit('downloadTemplate')
    }
  }
}
</script>

<style lang="less" scoped>
.upload-modal {
  .ant-input {
    height: 40px;
    color: #000000;
  }
  .ant-input-wrapper.ant-input-group {
    .ant-input {
      border-right: 0;
    }
    .ant-input-group-addon {
      background: #fff;
      font-size: 14px;
      font-weight: 400;
      color: #5e7a92;
      line-height: 20px;
    }
  }
  .ant-input-affix-wrapper {
    .ant-input-suffix img {
      width: 23px;
      height: 23px;
    }
  }
  .content {
    display: flex;
    position: relative;
    justify-content: center;
    .upload-file {
      width: 100%;
      height: 168px;
      position: relative;
      .file {
        top: 0;
        left: 0;
        opacity: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
        cursor: pointer;
        position: absolute;
      }
    }
    .success {
      width: 100%;
      height: 100%;
      display: flex;
      z-index: 2;
      color: #429a46;
      position: absolute;
      align-items: center;
      background: #fcfcfc;
      justify-content: center;
      border: 1px dashed #429a46;
      border-radius: 5px;
      font-size: 16px;
    }
    .fileTemplate {
      bottom: 40px;
      z-index: 1000;
      font-size: 12px;
      cursor: pointer;
      font-weight: 400;
      color: #7281a4;
      position: absolute;
      span {
        margin-right: 9px;
      }
      span:last-child {
        margin-right: 0;
      }
    }
  }
}
/deep/.ant-btn.file-button {
  width: 100% !important;
  height: 168px !important;
  padding-bottom: 20px;
  border-style: dashed;
  background: #fcfcfc;
  img {
    width: 26px;
    height: 26px;
    margin-bottom: 16px;
  }
  .text {
    font-size: 14px;
    font-weight: bold;
    color: #000000;
    line-height: 20px;
    letter-spacing: 1px;
  }
}
</style>
